import { MAX_LOCATIONS } from "../constants/Constants";
import { Area } from "../entities/Area";
import { invalidResult, validResult } from "../entities/ValidationResult";

/**
 * Checks a string exists and is non-empty.
 */
export const validateRequiredString = (str?: string) =>
	str == null || str.trim().length === 0 ? invalidResult("This field is required") : validResult;

/**
 * Checks an object exists.
 */
export const validateRequiredObject = (obj?: any) =>
	obj == null ? invalidResult("This field is required") : validResult;

/**
 * Checks an array has at least one element.
 */
export const validateRequiredEntry = (array?: any[]) =>
	array && array.length === 0 ? invalidResult("At least one option must be selected") : validResult;

/**
 * Checks that an area is valid.
 */
export const validateArea = (area?: Area) => {
	if (
		!area ||
		area.north == null ||
		area.west == null ||
		area.south == null ||
		area.east == null ||
		isNaN(area.north) ||
		isNaN(area.south) ||
		isNaN(area.west) ||
		isNaN(area.east)
	) {
		return invalidResult("All values must be provided");
	}

	if (area.north > 90 || area.north < -90) {
		return invalidResult("North must be between 90 and -90");
	}

	if (area.south > 90 || area.south < -90) {
		return invalidResult("South must be between 90 and -90");
	}

	if (area.east > 180 || area.east < -180) {
		return invalidResult("East must be between 180 and -180");
	}

	if (area.west > 180 || area.west < -180) {
		return invalidResult("West must be between 180 and -180");
	}

	if (area.north < area.south) {
		return invalidResult("North must be greater than south");
	}

	if (area.east < area.west) {
		return invalidResult("East must be greater than west");
	}

	const a = (area.north - area.south) * (area.east - area.west);
	if (a < 6) {
		return invalidResult("Area must be at least 6 degree squares");
	}

	return validResult;
};

/* Validate number of locations is assigned a value between 1 and 500 */
export const validateNumLocations = (num?: number | null) =>
	num === null || num === undefined || num < 1 || num > MAX_LOCATIONS || !Number.isInteger(num)
		? invalidResult(`Enter a whole number between 1 and ${MAX_LOCATIONS}`)
		: validResult;
